import { Controller } from "stimulus"

export default class extends Controller {
  update(e) {
    this.element.src = e.detail.src
  }
}
